import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIsPro } from 'hooks/useIsPro';

import closeAlertIcon from 'assets/close-alert.svg';
import lowCreditsAlertIcon from 'assets/low-credits-alert.svg';

import { PLAN_CREDITS } from 'utlis/constants';

import styles from './styles.module.scss';

const LowCreditsAlert = ({ onClose }) => {
  const isPro = useIsPro();
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);

    if (onClose) {
      onClose();
    }
  };

  // Auto-close after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 10000); // 10 seconds

    // Cleanup timer if component unmounts or user manually closes
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles['low-credits-alert']}>
      <div className={styles['alert-content']}>
        <div className={styles['alert-header']}>
          <div className={styles['alert-icon']}>
            <img src={lowCreditsAlertIcon} alt="Low Credits Alert" />
          </div>
          <span className={styles['alert-title']}>
            You've run out of credits
          </span>
          <button className={styles['alert-close']} onClick={handleClose}>
            <img src={closeAlertIcon} alt="Close Alert" />
          </button>
        </div>
        <div className={styles['alert-description']}>
          {`You'll get ${isPro ? PLAN_CREDITS.PRO : PLAN_CREDITS.FREE} additional credits the 1st day of next month`}
        </div>
      </div>
    </div>
  );
};

LowCreditsAlert.propTypes = {
  onClose: PropTypes.func,
};

export default LowCreditsAlert;
